import React, { useState, useEffect } from "react";
import editIcon from "../../../assets/images/editIcon.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { fetchFestivalById } from "../../../redux/festivalSlice";
import { getDate } from "../../../helpers/helperFunction";

const ReviewFestival = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const festivalDetails =
    useSelector((state) => state.festival.festivalDetails);
  console.log()
  const { festivalId } = useParams();

  // Navigate to the edit category page
  const editCategory = (festivalId) => {
    navigate(`/edit-festival-date/${festivalId}`, {
      state: {
        actionType: "edit", // Indicate this is for editing
        festivalDetails, // Pass the entire category details object
      },
    });
  };
  console.log("=================================\n")
  console.log("FesivalDetails ::",festivalDetails,'\nFestival ID:::',festivalId);
  console.log("=================================\n");

  useEffect(() => {
    if (festivalId) {
      dispatch(fetchFestivalById(festivalId));
    }
  }, [dispatch, festivalId]);

  return (
    <>
      <nav aria-label="breadcrumb" className="bread-box">
        <div>
          <h1 className="fprimary">Review Festival</h1>
          <h5>Review the festival details</h5>
        </div>
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#">Festivals</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Review Festival
            </li>
          </ol>
        </div>
      </nav>

      <div className="card mt-3 bg-stage">
        {/* Category Details */}
        <div className="card-body">
          <div className="mb-2">
            <h1 className="fprimary">
              Festival Details&nbsp;&nbsp;
              <button
                className="icon-clay mr-2"
                onClick={() => editCategory(festivalId, "festivalDetails")}
              >
                <img src={editIcon} alt="Edit Category" />
              </button>
            </h1>
          </div>
          <div className="row mt-4">
            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 border-end pe-2">
                  <p className="font-13 mb-0">Festival Name</p>
                  <div className="bg-slash font-14">
                    {festivalDetails.name || "-"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="d-flex justify-content-between indect">
              <div className="left-box w-100 border-end pe-2">
                <p className="font-13 mb-0 ">Festival Start Date</p>
                <div className="bg-slash font-14">
                  {getDate(festivalDetails?.startDate)}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex justify-content-between indect">
              <div className="left-box w-100 border-end pe-2">
                <p className="font-13 mb-0 ">Festival End Date</p>
                <div className="bg-slash font-14">
                  {getDate(festivalDetails?.endDate)}
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 border-end pe-2">
                  <p className="font-13 mb-0">Festival Description</p>
                  <div className="bg-slash font-14">
                    {festivalDetails.description || "-"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Languages */}
        {/* <div className="card-body">
          <div className="mb-2">
            <h1 className="fprimary">Languages&nbsp;&nbsp;</h1>
          </div>
          <div className="row .ms-4">
            {festivalDetails.languages &&
            festivalDetails.languages.length > 0 ? (
              festivalDetails.languages.map((languageItem, index) => (
                <div className="col-md-6" key={languageItem._id}>
                  <div className="d-flex justify-content-between indect">
                    <div className="left-box w-100 pe-2">
                      <p className="font-13 mb-0">
                        Language ({languageItem.language})
                      </p>
                      <div className="bg-slash font-14">
                        {languageItem.value}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-md-12">
                <div className="bg-slash font-14">No languages available</div>
              </div>
            )}
          </div>
          <img
            src={festivalDetails.image}
            alt="Product"
            className="img-thumbnail m-2"
            style={{ width: "100px", height: "100px" }}
          />
        </div> */}

        {/* Created and Updated Timestamps */}
        {/* <div className="card-body">
          <div className="row mt-4">
            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 pe-2">
                  <p className="font-13 mb-0">Active</p>
                  <div className="bg-slash font-14">
                    {festivalDetails.isActive ? "Yes" : "No"}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 pe-2">
                  <p className="font-13 mb-0">Allowed in Subscription</p>
                  <div className="bg-slash font-14">
                    {festivalDetails.isAllowedInSubscription ? "Yes" : "No"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default ReviewFestival;
